<template>
  <div>
    <div class="row">
      <table
        class="col-md-12"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <tr>
            <th
              class="text-left"
              width="5%"
            >Seq.</th>
            <th
              class="text-left"
              width="30%"
            >Pendência</th>
            <th
              class="text-left"
              width="30%"
            >Setor</th>
            <th
              class="text-left"
              width="10%"
            >Data da pendência</th>
            <th
              class="text-left"
              width="5%"
            >Status</th>
            <th
              class="text-left"
              width="15%"
            >Local da pendência</th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="arrayPendencias.length == 0">
            <td
              class="text-center"
              colspan="50"
            >{{msgNenhumRegistroEncontrado()}}</td>
          </tr>
          <tr
            v-for="obs in arrayPendencias"
            v-bind:key="obs.codObservacao"
          >
            <td class="text-left">
              {{obs.numSequencia}}
            </td>
            <td class="text-left">
              {{obs.txtPendencia}}
            </td>
            <td class="text-left">
              {{obs.desSetorPendencia}}
            </td>
            <td class="text-left">
              {{ obs.datPendenciaFormatadoSemHora }}
            </td>
            <td class="text-left">
              {{obs.indStatusPendencia}}
            </td>
            <td class="text-left">
              {{obs.indLocalPendencia === 'INT' || obs.indLocalPendencia === 'Interna' ? 'Interna' : 'Externa'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import msg from 'components/util/msg'
import util from 'components/util/util'
export default {
  props: {
    paginaStatus: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      arrayPendencias: []
    }
  },
  mounted: function () {
    var paginaStatus = this.paginaStatus
    this.carregarComponente(paginaStatus.arrayPendencias)
  },
  methods: {
    msgNenhumRegistroEncontrado () {
      return msg.m(6)
    },
    carregarComponente (arrayPendencias) {
      this.arrayPendencias = []
      if (util.validarCampo(arrayPendencias)) {
        if (arrayPendencias.length > 0) {
          this.arrayPendencias = arrayPendencias
        } else {
          this.arrayPendencias = []
        }
      }
    },
    getObjeto () {
    }
  },
  computed: {},
  watch: {},
  components: {}
}
</script>
